import { render, staticRenderFns } from "./viewNoticeSimpleDetailFB.vue?vue&type=template&id=0d9e7578&scoped=true"
import script from "./viewNoticeSimpleDetailFB.vue?vue&type=script&lang=js"
export * from "./viewNoticeSimpleDetailFB.vue?vue&type=script&lang=js"
import style0 from "./viewNoticeSimpleDetailFB.vue?vue&type=style&index=0&id=0d9e7578&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9e7578",
  null
  
)

export default component.exports